import { useQuery } from '@tanstack/react-query';
import { AccountApi, Configuration } from 'oura-account-api-client';

import { CompletedMemberDataExport } from 'apps-common/types';
import { logger } from 'apps-common/utils/logger';

const api = new AccountApi(new Configuration({ basePath: import.meta.env.VITE_ACCOUNT_API_URL }));

export const useGetMemberDataExportRedirect = (dataExport: CompletedMemberDataExport) =>
  useQuery<string>({
    queryKey: ['useGetMemberDataExportRedirect', dataExport],
    queryFn: async () => {
      logger.debug('Checking download URL redirect for member data export', { dataExport });

      try {
        const { data } = await api.getMemberDataExportDownloadUrl(
          { requestId: dataExport.id },
          {
            withCredentials: true,
          },
        );

        const { status, downloadUrl } = data;

        if (!downloadUrl) {
          logger.debug('No download URL redirect found for member data export', { dataExport, status });
          throw new Error('No download URL found');
        }

        logger.debug('Download URL redirect found for member data export');
        return downloadUrl;
      } catch (error) {
        logger.debug('Failed to fetch download URL for member data export', {
          dataExport,
          error,
        });
      }

      throw new Error('Failed to fetch download URL');
    },
    retry: false,
    staleTime: Infinity,
    enabled: false,
    refetchOnWindowFocus: false,
  });
